export class NotImplementedError extends Error {}
